import BaggageList from './BaggageList';

export default BaggageList;
